<template>
  <div class="tab-management flex-box">
    <div class="tab-management-title">{{ title }}</div>
    <div class="tab-management-description">{{ description }}</div>
    <div class="tab-container">
      <mobile-tab-fold :tabs="tabList" :value="activeName" @input="onFoldTab" />
      <el-tabs v-model="activeName" @tab-click="tabsChange">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in tabList" :key="k">
          <div class="content-wrap">
            <div class="blue-bj" :class="{'bj-left': isLeft }"></div>
            <div class="content">
              <div class="content-left">
              <el-image
                class="preview-shot"
                fit="contain"
                :src="item.img"
                :preview-src-list="previewImgs"
              />
              </div>
              <div class="content-right">
                <div class="info-wrap">
                  <div class="content-num">{{ item.num }}</div>
                  <div class="content-name">{{ item.label }}</div>
                  <div class="content-desc" v-if="item.description">{{ item.description }}</div>
                  <div v-if="item.descArr" class="content-list">
                    <div v-for="(subItem, ks) in item.descArr" :key="ks" ><span>{{subItem.name}}：</span>{{subItem.content}}</div>
                  </div>
                </div>
              </div>
              <div class="right-bj">
                <img v-lazy="fkbj" alt="">
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    
  </div>
</template>

<script>
import fkbj from '@/assets/images/fkbj.png'
import MobileTabFold from '@/components/MobileTabFold/index.vue'
export default {
  components: { MobileTabFold },
  props: {
    isLeft: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      fkbj,
      activeName: 'first',
      activeIndexOne: 0,
      timeoutOne: null,
    }
  },
  computed: {
    previewImgs() {
      return this.tabList.map(item => item.img).filter(Boolean)
    }
  },
  watch: {
    activeName: {
      handler(n) {
      }
    }
  },
  mounted() {
    // this.timeoutModuleOne();
  },
  destroyed() {
    // this.clearTimeoutOne();
  },
  methods: {
    timeoutModuleOne() {
      this.timeoutOne = setInterval(() => {
        if (this.activeIndexOne === this.tabList.length -1) {
          this.activeIndexOne = 0;
        } else {
          this.activeIndexOne++;
        }
        this.activeName = this.tabList[this.activeIndexOne].name
      }, 5000)
    },
    clearTimeoutOne() {
      clearInterval(this.timeoutOne)
    },
    tabsChange(val) {
      this.activeIndexOne = Number(val.index);
    },
    onFoldTab(name) {
      this.activeName = name
      const idx = this.tabList.findIndex(item => item.name === name)
      if (idx >= 0) this.activeIndexOne = idx
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.tab-management {
  flex-direction: column;
  align-items: center;

  .tab-management-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 4rem;
    padding: 9.9rem 0 1.9rem;
  }

  .tab-management-description {
    font-size: 1.8rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 2.8rem;
    padding: 0 26rem 6rem;
    text-align: center;
  }

  .tab-container {
    width: 100%;
    display: flex;
    justify-content: center;

    ::v-deep .el-tabs {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__header {
        width: calc(192rem - 52rem);
        margin: 0;

        .el-tabs__nav {
          width: 100%;
          display: flex;

          .el-tabs__item {
            flex: 1;
            // width: 24rem;
            height: 4.6rem;
            display: inline-flex;
            justify-content: center;
            font-size: 2rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 2rem;
            box-shadow: none;
          }

          .el-tabs__active-bar {
            height: 0.2rem;
            width: 33%;
            background-color: #FB0000;
          }

          .el-tabs__item.is-active, .el-tabs__item:hover {
            color: #FB0000;
          }
        }
      }
      .el-tabs__content {
        width: 100%;
      }
    }

  }
  .content-wrap {
    position: relative;
    height: 71rem;
    width: 100%;
    background: linear-gradient(90deg, #fbfdff 0%, #eef6ff 100%);
    .blue-bj {
      position: absolute;
      width: 37rem;
      height: 71rem;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      opacity: 0.8;
      top: 0;
      right: 0;
    }
    .bj-left {
      left: 0;
    }
    .content {
      position: absolute;
      top: 6rem;
      left: 26rem;
      width: 140rem;
      height: 55.8rem;
      background: #FFFFFF;
      padding: 5.4rem;
      display: flex;
      .content-left {
        width: 70rem;
        height: 45rem;
        img,
        ::v-deep .preview-shot {
          width: 100%;
          height: 100%;
          display: block;
          cursor: zoom-in;
        }
        ::v-deep .preview-shot .el-image__inner {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }
      .content-right {
        flex: 1;
        padding: 2.5rem 0 0 7.3rem;
        .info-wrap {
          height: 27.5rem;
          position: relative;
          .content-num {
            font-family: DINAlternate, DINAlternate;
            font-weight: bold;
            font-size: 7.2rem;
            color: #3674FE;
            line-height: 7.2rem;
            text-align: left;
            font-style: normal;
            opacity: .1;
            position: absolute;
            left: 0;
            top: 0;
          }
          .content-name {
            font-size: 3.2rem;
            font-weight: 600;
            color: #333333;
            line-height: 3.6rem;
            padding: 3.6rem 0 2.4rem;
            border-bottom: 0.1rem solid rgba(54, 116, 254, .21);
          }
          .content-desc {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 1.6rem;
            color: #333333;
            line-height: 2.8rem;
            text-align: left;
            font-style: normal;
            padding-top: 2.1rem;
            width: 48rem;
          }
          .content-list {
            margin-top: 1.5rem;
            width: 48rem;
            & > div {
              margin-bottom: 2rem;
              font-size: 1.6rem;
              line-height: 2.8rem;
              color: #333333;
              span {
                color: #3674FE;
              }
            }
          }
        }
      }
      .right-bj {
        position: absolute;
        right:0;
        bottom: 0;
        width: 32.3rem;
        height: 32.6rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .tab-management {
    .tab-management-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 3.2rem 1.6rem 1.2rem;
      text-align: center;
    }
    .tab-management-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 1.6rem 2.4rem;
    }
    ::v-deep .el-tabs__header {
      display: none !important;
    }
    .content-wrap {
      height: auto;
      .blue-bj,
      .right-bj {
        display: none;
      }
      .content {
        position: relative;
        top: auto;
        left: auto;
        width: 100%;
        height: auto;
        padding: 2.4rem 1.6rem 1.6rem;
        flex-wrap: wrap;
        .content-left {
          width: 100%;
          height: auto;
          img,
          ::v-deep .preview-shot,
          ::v-deep .preview-shot .el-image__inner {
            height: auto;
            object-fit: contain;
          }
        }
        .content-right {
          padding: 1.2rem 0 0;
          .info-wrap {
            height: auto;
            .content-num {
              font-size: 4.8rem;
              line-height: 4.8rem;
            }
            .content-name {
              font-size: 2rem;
              line-height: 2.8rem;
              padding: 2.4rem 0 1.2rem;
            }
            .content-desc {
              width: 100%;
              font-size: 1.4rem;
              line-height: 2.2rem;
              padding-top: 1.2rem;
            }
            .content-list {
              width: 100%;
              margin-top: 1.2rem;
              > div {
                margin-bottom: 1.2rem;
                font-size: 1.4rem;
                line-height: 2.2rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
